// extracted by mini-css-extract-plugin
export default {"text":"termsandconditions_text__AErGN","heading":"termsandconditions_heading__fDnm9"};